interface Header {
  icon?: string;
  name: string;
  subTitle?: string | null;
  bordered?: boolean;
}

interface Footer {
  bordered?: boolean;
}

interface Prop {
  title?: string;
  source?: string | string[];
  classes?: string;
  separator?: boolean;
  type?: string;
  cellClasses?: string;
  id?: string;
  src?: string;
}

interface Component {
  props: Prop;
  component?: string;
}

enum CardAppearances {
  card = "card",
  row = "row",
}

export { Header, Prop, Component, CardAppearances, Footer };
